<svg *ngIf="!loadingStore" viewBox="0 0 960 540" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="min-h-screen min-w-screen fixed left-0"
    style="bottom:-10rem" preserveAspectRatio="none">
    <rect x="0" y="0" width="960" height="540" fill="var(--surface-ground)"></rect>
    <path
        d="M0 331L26.7 321C53.3 311 106.7 291 160 291C213.3 291 266.7 311 320 329.5C373.3 348 426.7 365 480 373.2C533.3 381.3 586.7 380.7 640 373.8C693.3 367 746.7 354 800 341.2C853.3 328.3 906.7 315.7 933.3 309.3L960 303L960 541L933.3 541C906.7 541 853.3 541 800 541C746.7 541 693.3 541 640 541C586.7 541 533.3 541 480 541C426.7 541 373.3 541 320 541C266.7 541 213.3 541 160 541C106.7 541 53.3 541 26.7 541L0 541Z"
        [attr.fill]="primary_color || null" stroke-linecap="round" stroke-linejoin="miter"></path>
</svg>
<div class="grid justify-content-center px-3 md:px-5 py-4 grid-nogutter bg-gray-100 min-h-screen">
    <div class="col-12 md:col-10 lg:col-8 xl:col-6 s-s-l-screenCreatorsAuth">
        <!-- CARD PERFIL/LOJA -->
        <div *ngIf="loadingStore" class="profile-card surface-card border-round-2xl shadow-none mb-4">
            <div class="cover">
                <p-skeleton width="100%" height="120px" styleClass="block border-round-top-2xl"></p-skeleton>
            </div>
            <div class="p-4 relative">
                <div class="avatar">
                    <p-skeleton width="72px" height="72px" styleClass="border-round-2xl"></p-skeleton>
                </div>
                <button pButton class="button-text button-rounded p-button-outlined action-btn" icon="pi pi-ellipsis-v"
                    disabled></button>

                <div class="mt-4">
                    <p-skeleton width="30%" height="20px" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="55%" height="14px"></p-skeleton>
                </div>

                <div class="flex gap-2 mt-3">
                    <p-skeleton width="64px" height="28px" styleClass="border-round-lg"></p-skeleton>
                    <p-skeleton width="84px" height="28px" styleClass="border-round-lg"></p-skeleton>
                </div>
            </div>
        </div>

        <div *ngIf="!loadingStore" class="profile-card surface-card border-round-2xl shadow-none mb-4">
            <div class="cover" [ngStyle]="{
                'background-image': 'url(' + wallpaper + ')',
                'background-size': 'cover',
                'background-position': 'center center',
                'background-repeat': 'no-repeat'
              }"></div>
            <div class="p-4 relative">
                <div class="avatar">
                    <img [src]="storeProfileImg" alt="Logo" />
                    <span class="status-dot"></span>
                </div>
                <button pButton type="button" class="button-text button-rounded p-button-outlined action-btn"
                    icon="pi pi-ellipsis-v" (click)="menu.toggle($event); $event.stopPropagation();">
                </button>

                <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body">
                </p-menu>
                <div class="mt-3">
                    <h2 class="m-0 text-900 text-xl md:text-2xl font-semibold">{{ store_name }}</h2>
                    <p class="m-0 text-600 text-sm">{{ store_description }}</p>
                </div>
                <div class="flex gap-2 mt-3">
                    <a [href]="link_store" target="_blank" rel="noopener" class="no-underline">
                        <p-tag value="Site" class="s-s-l-btnsCreatorsTag " icon="bi bi-shop" [rounded]="true"
                            [style.--tag-bg]="primary_color"></p-tag>
                    </a>
                    <a [href]="link_player" target="_blank" rel="noopener" class="no-underline">
                        <p-tag value="Player" class="s-s-l-btnsCreatorsTag " icon="pi pi-play" [rounded]="true"
                            [style.--tag-bg]="primary_color"></p-tag>
                    </a>
                </div>
            </div>
        </div>

        <!-- BLOCO LOGIN (Conectar conta) -->
        <!-- SKELETON -->
        <div *ngIf="loadingStore" class="card border-round-2xl shadow-none relative p-4">
            <p-skeleton width="20%" height="18px" styleClass="mb-3"></p-skeleton>

            <p-skeleton width="12%" height="14px" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100%" height="44px" styleClass="mb-3 border-round-lg"></p-skeleton>

            <p-skeleton width="10%" height="14px" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100%" height="44px" styleClass="mb-3 border-round-lg"></p-skeleton>

            <p-skeleton width="100%" height="44px" styleClass="border-round-lg"></p-skeleton>
        </div>

        <div *ngIf="!loadingStore" class="card border-round-2xl shadow-none relative p-4">
            <div class="w-full text-left mb-3">
                <div class="text-900 text-xl font-semibold">
                    {{ mode === 'signin' ? 'Log in' : 'Cadastrar' }}
                </div>
            </div>


            <!-- Passo 1: Telefone -->
            <form *ngIf="!otpSent" (ngSubmit)="sendOTP()" class="flex flex-column">
                <div class="mb-2 flex flex-column">
                    <input id="phone" type="tel" pInputMask mask="(99) 99999-9999" class="p-inputtext p-component mb-1"
                        placeholder="(99) 99999-9999" [(ngModel)]="phone" name="phone" [disabled]="isLoading" required
                        #phoneInput="ngModel" (blur)="onPhoneBlur()" />
                </div>
                <!-- Nome obrigatório só se for novo -->
                <div *ngIf="mode === 'signup'" class="mb-2 mt-2 w-full flex flex-column">
                    <input id="name" type="text" class="p-inputtext p-component mb-1" placeholder="Seu nome completo"
                        [(ngModel)]="name" name="name" required [disabled]="isLoading" (blur)="nameTouched = true" />
                    <small class="p-error mb-3" *ngIf="nameTouched && !name">
                        Nome é obrigatório para novos usuários.
                    </small>
                </div>

                <button pButton pRipple label="Enviar código para WhatsApp" class="w-full mt-2 s-s-l-btnsCreators"
                    [loading]="isLoading" [disabled]="
                    !isPhoneValid() || (mode === 'signup' && !name) || isLoading" [style.--btn-bg]="primary_color"
                    [style.--btn-hover-bg]="secondary_color || primary_color">
                </button>

                <!-- Divider Customizado -->
                <div class="custom-divider">
                    <div class="divider-line"></div>
                    <div class="divider-text">OU</div>
                    <div class="divider-line"></div>
                </div>

                <button type="button" class="p-button p-component p-button-outlined w-full" (click)="toggleMode()">
                    <span class="p-button-label">
                        {{ mode === 'signin' ? 'Criar conta' : 'Entrar' }}
                    </span>
                </button>
            </form>



            <!-- Passo 2: OTP -->
            <form *ngIf="otpSent" (ngSubmit)="submitOTP()" class="flex flex-column">
                <ng-otp-input [config]="{length: 6, inputClass: 'otp-input', allowNumbersOnly: true}"
                    (onInputChange)="onOtpInputChange($event)"></ng-otp-input>
                <small class="p-error mt-2" *ngIf="errorMsg">
                    {{ errorMsg }}
                </small>
                <div class="flex justify-content-between mt-4">
                    <button pButton pRipple type="button" class="button-text s-s-l-btnsCreators" [label]="resendLabel()"
                        (click)="onClickResend()" [disabled]="isLoading || cooldown > 0"
                        [style.--btn-bg]="primary_color" [style.--btn-hover-bg]="secondary_color || primary_color">
                    </button>
                    <button pButton pRipple type="submit" label="Confirmar" [loading]="isLoading"
                        class="button-success s-s-l-btnsCreators" [disabled]="!otp || isLoading"
                        [style.--btn-bg]="primary_color"
                        [style.--btn-hover-bg]="secondary_color || primary_color"></button>
                </div>
                <!-- Mensagem de erro estilo PrimeNG -->

            </form>


        </div>
    </div>
</div>